import { MyUploadsTable } from '@/routes/_auth/_modules/_app/my-uploads/-components/MyUploadsTable'
import { crtMyUploadsSearchSchema } from '@/hooks/queries/uploads/useUploadToS3'
import { CRT_CSV_UPLOAD_TYPES } from '@repo/csv'
import { createFileRoute } from '@tanstack/react-router'

const CRT_MY_UPLOAD_TYPES = [...CRT_CSV_UPLOAD_TYPES] as const

export const Route = createFileRoute('/_auth/_modules/crt/my-uploads/')({
  component: MyUploadsPage,
  validateSearch: (search) => crtMyUploadsSearchSchema.parse(search),
})

function MyUploadsPage() {
  const navigate = Route.useNavigate()
  const search = Route.useSearch()

  return (
    <MyUploadsTable
      module="crt"
      uploadTypes={CRT_MY_UPLOAD_TYPES}
      allUploadsPermission="crt_upload_allUploads_view"
      search={search}
      navigate={navigate}
      onOpenUpload={(scope, fileName) =>
        navigate({ to: '/crt/my-uploads/$scope/$fileName', params: { scope, fileName } })
      }
    />
  )
}
